import React from 'react';
import { SvgIcon } from '@mui/material';
const SvgCheckWhite = (props) => (
  <SvgIcon {...props} title="CheckWhite">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={{
        enableBackground: 'new 0 0 24 24'
      }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M21 7 9 19l-5.5-5.5 1.4-1.4L9 16.2 19.6 5.6 21 7z"
        style={{
          fill: '#fff'
        }}
      />
    </svg>
  </SvgIcon>
);
export default SvgCheckWhite;
